import request from 'sb-request'
import { reducers, getState } from 'redux/core'
import { array, getGqlQuery, constants } from 'common/helpers'


// const mockItems = [
//   {
//     'id': 815,
//     'url': '/makeup/Longwear-Eyeliner-Chameleon',
//     'name': 'Palette #01',
//     'brand': 'DECK OF SCARLET',
//     'img': 'https://scentbird.s3.eu-west-1.amazonaws.com/test/product/desc/normal/img-815.jpg',
//     'sex': 'female',
//     'category': 'Makeup lip',
//     'type': 'EyeLiner',
//     'labels': [
//       'new-arrival',
//       'visible',
//       'available',
//     ],
//   },
//   {
//     'id': 816,
//     'url': '/makeup/Long-Lasting-Liquid-Eyeliner-Galaxy',
//     'name': 'Palette #02',
//     'brand': 'DECK OF SCARLET',
//     'img': 'https://cdn.scentbird.com/test/product/desc/normal/img-816.jpg',
//     'sex': 'female',
//     'category': 'Makeup eye',
//     'type': 'EyeLiner',
//     'labels': [
//       'new-arrival',
//       'visible',
//       'available',
//       'limited-edition',
//     ],
//   },
//   {
//     'id': 817,
//     'url': '/makeup/Long-Lasting-Liquid-Eyeliner-Koko-Kavari',
//     'name': 'Palette #03',
//     'brand': 'DECK OF SCARLET',
//     'img': 'https://cdn.scentbird.com/test/product/desc/normal/img-817.jpg',
//     'sex': 'female',
//     'category': 'Makeup lip',
//     'type': 'LipPencil',
//     'labels': [
//       'new-arrival',
//       'visible',
//       'available',
//       'limited-edition',
//       'sold-out',
//     ],
//   },
//   {
//     'id': 818,
//     'url': '/makeup/One-Stroke-Graphic-Lip-Crayon-Mia',
//     'name': 'Palette #04',
//     'brand': 'DECK OF SCARLET',
//     'img': 'https://cdn.scentbird.com/test/product/desc/normal/img-818.jpg',
//     'sex': 'female',
//     'category': 'Makeup eye',
//     'type': 'LipLiner',
//     'labels': [
//       'new-arrival',
//       'visible',
//       'available',
//     ],
//   },
//   {
//     'id': 817,
//     'url': '/makeup/Long-Lasting-Liquid-Eyeliner-Koko-Kavari',
//     'name': 'Palette #03',
//     'brand': 'DECK OF SCARLET',
//     'img': 'https://cdn.scentbird.com/test/product/desc/normal/img-817.jpg',
//     'sex': 'female',
//     'category': 'Makeup lip',
//     'type': 'LipCrayon',
//     'labels': [
//       'new-arrival',
//       'visible',
//       'available',
//     ],
//   },
//   {
//     'id': 818,
//     'url': '/makeup/One-Stroke-Graphic-Lip-Crayon-Mia',
//     'name': 'Palette #04',
//     'brand': 'DECK OF SCARLET',
//     'img': 'https://cdn.scentbird.com/test/product/desc/normal/img-818.jpg',
//     'sex': 'female',
//     'category': 'Makeup eye',
//     'type': 'LipCrayon',
//     'labels': [
//       'new-arrival',
//       'visible',
//       'available',
//     ],
//   },
// ]

// for mobiles only
const openCategoriesOverlay = () => reducers.models.products.setCategoriesOverlayVisibility(true)
const closeCategoriesOverlay = () => reducers.models.products.setCategoriesOverlayVisibility(false)

const openFiltersOverlay = (initialActiveFilter = null) => {
  reducers.models.products.setFiltersOverlayInitialFilter(initialActiveFilter)
  reducers.models.products.setFiltersOverlayVisibility(true)
}

const closeFiltersOverlay = () => {
  reducers.models.products.setFiltersOverlayVisibility(false)
  reducers.models.products.setFiltersOverlayInitialFilter(null)
}

const setFetching = (value) => reducers.models.products.setFetching(value)

const fetchBrands = (gender) =>
  request.get('rest/engine/smartsearch/bestsellersbrands', {
    query: {
      gender,
    },
    modifyResult: ({ brands }) => brands.map(({ name, count }) => ({
      label: name,
      value: name,
      count,
    })),
  })
    .then((brands) => reducers.models.products.setBrands(brands))

const requestProductsGql = (params) => {
  const { models: { products: { activeFilters: { brands } } } } = getState()

  if (brands.length) {
    params.brands = brands
  }

  const productsQueryParams = getGqlQuery('products', params)

  setFetching(true)

  request.post('graphql?name=products', {
    body: {
      query: `{
        ${productsQueryParams} {
          id
          url
          sex
          img
          type
          name
          brand
          rating
          labels
          category
          upchargePrice
        }
      }`,
    },
    modifyResult: ({ products = [] }) => products,
  })
    .then(
      (products) => {
        reducers.models.products.setProducts(products)
        reducers.models.products.setProductCount(products.length)
      },
      (error) => {
        console.error(error)
        reducers.models.products.setProducts([])
        reducers.models.products.setProductCount(0)
        return Promise.reject()
      }
    )
}

const fetchProductsForBody = (gender) => requestProductsGql({
  groups: ['BathBody'],
  productsFeed: constants.productsFeed.bodyWashes,
  types: ['Scrub', 'ShowerGel', 'Moisturizer'],
  gender,
})

const fetchBodyLip = (gender) => requestProductsGql({
  groups: ['BathBody'],
  productsFeed: constants.productsFeed.lipBalms,
  types: ['LipBalm'],
  gender,
})

const fetchSkincareProducts = (gender) => requestProductsGql({
  groups: ['BathBody'],
  productsFeed: constants.productsFeed.bodyWashes,
  types: ['Scrub', 'LipBalm', 'Cream', 'ShowerGel', 'Moisturizer'],
  gender,
})

const fetchNewScentbird = (gender) => requestProductsGql({
  category: 'newarrivals',
  groups: ['Perfume', 'BathBody', 'HomeFragrance', 'CandleSet', 'Makeup', 'PersonalCare'],
  brand: 'Scentbird',
  gender,
})

const fetchScentbird = (gender) => requestProductsGql({
  productsFeed: constants.productsFeed.scentbirdProducts,
  groups: ['Perfume', 'BathBody', 'HomeFragrance', 'CandleSet', 'Makeup', 'PersonalCare'],
  brand: 'Scentbird',
  gender,
})

const fetchHandCreams = (gender) => requestProductsGql({
  groups: ['BathBody'],
  types: ['Cream'],
  gender,
})

const fetchCandles = () => requestProductsGql({
  productsFeed: constants.productsFeed.candles,
  groups: ['HomeFragrance'],
})

const fetchBestsellersProducts = (gender) => requestProductsGql({
  productsFeed: constants.productsFeed.bestsellersMain,
  category: 'bestsellers',
  groups: ['Perfume', 'BathBody', 'Makeup'],
  gender,
})

const fetchTossInProducts = (gender) => requestProductsGql({
  category: 'tossin',
  gender,
})

// const fetchTossInProducts      = (gender) => fetchProducts('rest/shop/tossin', gender)

const fetchGoldCollection = (gender) => requestProductsGql({
  category: 'gold-collection',
  gender,
})

const fetchMakeupProductsByBrand = (brand) => () => requestProductsGql({
  groups: ['Makeup'],
  brand,
})

const fetchRecommendations = ({ gender, limit = 12 }) => {
  setFetching(true)

  return request.get('rest/shop/recommendations', {
    query: {
      gender,
      limit,
    },
  })
    .then(
      ({ perfumes }) => {
        reducers.models.products.setProducts(perfumes)
        reducers.models.products.setProductCount(perfumes.length)

        return perfumes
      },
      (error) => {
        console.error(error)
        reducers.models.products.setProducts([])
        reducers.models.products.setProductCount(0)
        return Promise.reject()
      }
    )
}

const fetchPopularByGender = (params) => {
  const { gender, category = 'popularity', limit = 72, offset = 0, randomLimit = 0, notes } = params

  setFetching(true)

  const productsQueryParams = getGqlQuery('products', {
    gender,
    category,
    limit,
    offset,
    notes,
    groups: [ 'Perfume' ],
  })

  return request.post('graphql?name=fetchPopularByGender', {
    body: {
      query: `{
        ${productsQueryParams}{
          id
          img
          sex
          url
          name
          type
          brand
          rating
          labels
          category
          upchargePrice
        }
      }`,
    },
    modifyResult: ({ products }) => {
      if (randomLimit > 0) {
        return array.shuffle(products).slice(0, randomLimit)
      }
      return products
    },
  })
    .then(
      (products) => {
        reducers.models.products.setProducts(products)
        reducers.models.products.setProductCount(products.length)

        return products
      },
      (error) => {
        console.error(error)
        reducers.models.products.setProducts([])
        reducers.models.products.setProductCount(0)
        return Promise.reject()
      }
    )
}

/**
 *
 * @param {String} label
 */
const toggleActiveBrand = (label) => reducers.models.products.toggleActiveBrand(label)

const clearProducts = () => reducers.models.products.clearProducts()

const clearFilters = () => reducers.models.products.clearFilters()

const clearFilter = (filter) => reducers.models.products.clearFilter(filter)

const setActiveFilter = ({ activeFilter, value }) => reducers.models.products.setActiveFilter({ activeFilter, value })

const toggleActiveFilter = ({ activeFilter, value }) => reducers.models.products.toggleActiveFilter({ activeFilter, value })

const addFilterValue = ({ filter, value }) => reducers.models.products.addFilterValue({ filter, value })

const removeFilterValue = ({ filter, value }) => reducers.models.products.removeFilterValue({ filter, value })


export default {
  openCategoriesOverlay,
  closeCategoriesOverlay,
  openFiltersOverlay,
  closeFiltersOverlay,

  setFetching,

  fetchBrands,
  fetchNewScentbird,
  fetchScentbird,
  fetchHandCreams,
  fetchProductsForBody,
  fetchBodyLip,
  fetchGoldCollection,
  fetchCandles,
  fetchBestsellersProducts,
  fetchTossInProducts,
  fetchMakeupProductsByBrand,
  fetchRecommendations,
  fetchPopularByGender,
  fetchSkincareProducts,

  clearFilters,
  clearProducts,
  clearFilter,

  toggleActiveBrand,
  setActiveFilter,
  toggleActiveFilter,
  addFilterValue,
  removeFilterValue,
}
